@if (withBreadcrumb) {
  <cap-breadcrumb></cap-breadcrumb>
}
<i class="fas fa-spinner fa-pulse fa-2x fa-fw mt-5 spinner"></i>
